export const useContent = async (path) => {
  const { data } = await useAsyncData(path, () => {
    return queryCollection("content").path(path).first();
  });
  if (!data.value) {
    throw createError({
      statusCode: 404,
      statusMessage: "Page not found",
    });
  }
  return data;
};
